<pu-period-calendar
  [formControl]="control()"
  [leftMonthToShowByDefault]="leftMonthToShowByDefault()"
  [maxDate]="maxDate()"
  [minDate]="minDate()"
  [label]="label()"
  [placeholder]="placeholder()" />
